import { APIGet } from '../services/API'

export const configure = (site) => dispatch => {

    dispatch({
        type: 'CONFIGURE',
        payload: {
            site: site,
        }
    });

}

export const getConfiguration = () => (dispatch, getState) => {

    // Get Site
    const { site } = getState().Settings;

    // Dispatch Result
    dispatch({
        type: 'GETTING_CONFIGURATION',
        payload: {
            ui: "loading",
        }
    });

    // Send Request To Get Events
    APIGet(site+'/api/v1/configure')
    .then(res => res.json())
    .then(json => {
        dispatch({ type: 'GET_CONFIGURATION_SUCCESS',payload: {ui:"success",configuration:json}});
    })
    .catch(e => {
        dispatch({ type: 'GET_CONFIGURATION_ERROR',payload: {ui:"error",message:e}});
    })

}
